import { render, staticRenderFns } from "./detail_pingjia.vue?vue&type=template&id=30db8208&scoped=true"
import script from "./detail_pingjia.vue?vue&type=script&lang=js"
export * from "./detail_pingjia.vue?vue&type=script&lang=js"
import style0 from "./detail_pingjia.vue?vue&type=style&index=0&id=30db8208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db8208",
  null
  
)

export default component.exports